import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { StoreService } from '../../core';
import { CoursesService } from 'core/services/courses.service';
import { ProfileService } from 'core/services/profile.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'lms-groups',
  templateUrl: './groups.component.html',
  styleUrls: ['./groups.component.scss']
})
export class GroupsComponent implements OnInit {
  public listId = 'GROUPS_LIST';
  public toolbarConfig: any;
  public noGroups: boolean;
  public listSubscription: Subscription;

  constructor(
    public titleService: Title,
    public translate: TranslateService,
    public profileService: ProfileService,
    public coursesService: CoursesService
  ) {}

  ngOnInit() {
    this.toolbarConfig = {
      list: {
        listId: this.listId,
        download: true,
        filterRow: true,
        columnChooser: this.profileService.canExecute('groups.column-chooser'),
        skeletor: true
      }
    };
    this.listSubscription = StoreService.get(this.listId).subscribe((value) => {
      if (value) {
        const hasGroups = value.docs.length > 0;
        const hasSearch = !!value.search;
        const hasFilters = value.filters && Object.keys(value.filters).filter((key) => key !== 'clientId').length > 0;
        this.noGroups = !hasGroups && !hasSearch && !hasFilters;
      }
    });
    this.titleService.setTitle(
      this.translate.instant('pageTitle.groups') + ' - ' + this.translate.instant('pageTitle.gamelearn')
    );
  }
}
